// Theme utility functions
export const THEMES = {
  LIGHT: "light",
  DARK: "dark",
};

// Function to toggle theme
export const toggleTheme = (currentTheme) => {
  return currentTheme === THEMES.LIGHT ? THEMES.DARK : THEMES.LIGHT;
};

// Get theme colors based on current theme (must match index.css)
export const getThemeColors = (theme) => {
  if (theme === THEMES.DARK) {
    return {
      primaryColor: '#3b82f6',
      darkPrimaryColor: '#2563eb',
      darkPrimaryShadowColor: 'rgba(59, 130, 246, 0.25)',
      secondaryColor: '#0f172a',
      textColor: '#f1f5f9',
      backgroundColor: '#0f172a',
      navbarBgColor: '#1e293b',
      cardBgColor: '#1e293b',
      cardTextColor: '#cbd5e1',
      navTextColor: '#f8fafc',
      borderColor: '#334155',
      hoverBgColor: '#2d3e5a',
      inputBgColor: '#0f172a',
      inputTextColor: '#f1f5f9',
      inputBorderColor: '#475569',
      buttonTextColor: '#ffffff',
      heroTextColor: '#ffffff',
      footerBgColor: '#020617',
      footerTextColor: '#94a3b8',
      successColor: '#4ade80',
      warningColor: '#facc15',
      errorColor: '#f87171',
      infoColor: '#60a5fa',
    };
  }

  return {
    primaryColor: '#2563eb',
    darkPrimaryColor: '#1d4ed8',
    darkPrimaryShadowColor: 'rgba(29, 78, 216, 0.43)',
    secondaryColor: '#ffffff',
    textColor: '#0f172a',
    backgroundColor: '#f8fafc',
    navbarBgColor: '#ffffff',
    cardBgColor: '#ffffff',
    cardTextColor: '#334155',
    navTextColor: '#1e293b',
    borderColor: '#e2e8f0',
    hoverBgColor: '#f1f5f9',
    inputBgColor: '#ffffff',
    inputTextColor: '#0f172a',
    inputBorderColor: '#cbd5e1',
    buttonTextColor: '#ffffff',
    heroTextColor: '#ffffff',
    footerBgColor: '#0f172a',
    footerTextColor: '#f8fafc',
    successColor: '#15803d',
    warningColor: '#a16207',
    errorColor: '#b91c1c',
    infoColor: '#1d4ed8',
  };
};

// Apply theme to document
export const applyTheme = (theme) => {
  const c = getThemeColors(theme);
  const root = document.documentElement.style;
  root.setProperty('--primary-color', c.primaryColor);
  root.setProperty('--dark-primary-color', c.darkPrimaryColor);
  root.setProperty('--dark-primary-shadow-color', c.darkPrimaryShadowColor);
  root.setProperty('--secondary-color', c.secondaryColor);
  root.setProperty('--text-color', c.textColor);
  root.setProperty('--background-color', c.backgroundColor);
  root.setProperty('--navbar-bg-color', c.navbarBgColor);
  root.setProperty('--card-bg-color', c.cardBgColor);
  root.setProperty('--card-text-color', c.cardTextColor);
  root.setProperty('--nav-text-color', c.navTextColor);
  root.setProperty('--border-color', c.borderColor);
  root.setProperty('--hover-bg-color', c.hoverBgColor);
  root.setProperty('--input-bg-color', c.inputBgColor);
  root.setProperty('--input-text-color', c.inputTextColor);
  root.setProperty('--input-border-color', c.inputBorderColor);
  root.setProperty('--button-text-color', c.buttonTextColor);
  root.setProperty('--hero-text-color', c.heroTextColor);
  root.setProperty('--footer-bg-color', c.footerBgColor);
  root.setProperty('--footer-text-color', c.footerTextColor);
  root.setProperty('--success-color', c.successColor);
  root.setProperty('--warning-color', c.warningColor);
  root.setProperty('--error-color', c.errorColor);
  root.setProperty('--info-color', c.infoColor);

  document.documentElement.setAttribute("data-theme", theme);
};
